// URLs
export const LOGIN_URL = "/login";
export const ONEPASS_LEARN_MORE = "https://onepass.com.au/";
export const ONEPASS_TERMS_AND_CONDITIONS = "/onepass-terms";
export const ONEPASS_OAUTH_REDIRECT = "/oauth_redirect/onepass";
export const ONEPASS_SUBSCRIBE_URL = "/onepass/subscribe";

// Analytics
export const DEFAULT_CLUB_CATCH_EVENT_ID = 3;
export const DEFAULT_CATCH_SELLER_ID = 1;

export const ONEPASS_MIGRATION_STATUS_QUERY_PARAM_KEY =
  "onepass-migration-status";
export const ONEPASS_DOUBLE_SUBSCRIPTION_QUERY_PARAM_KEY = "double-sub";
export const ONEPASS_LINK_QUERY_PARAM_KEY = "link-onepass";
export const ONEPASS_SUCCESS_NOTIFICATION_TOAST_PARAM_KEY = "showmessage";
